import { queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';

export const meQueryOptions = () =>
  queryOptions({
    queryKey: ['me'],
    queryFn: ({ signal }) => unwrap(api.GET('/api/me', { signal })),
    staleTime: 5 * 60_000,
  });
